<template>
  <StepTemplate
    class="StepSchedule"
    :error="error"
    stepName="stepSchedule"
    bottomBtn
    :disabledBtn="!hasOneDayActive"
    @nextStep="$emit('nextStep', 2)"
  >
    <v-container fluid class="Step-container overflow-x-auto">
      <v-row>
         <v-col class="Container-head pa-0" cols="3" sm="2" md="1">
          <div class="Row-label">{{ $t('weekOpening.day') }}</div>
          <div class="Row-start">{{ $t('weekOpening.open') }}</div>
          <div class="Row-end">{{ $t('weekOpening.close') }}</div>
          <div class="WeekOpening--small">
            {{ $t('weekOpening.slotMaximum') }}
            <div class="WeekOpenings-tooltips">
              <div class="WeekOpenings-tooltipButton">i</div>
              <div class="WeekOpenings-tooltipsContent">
                {{ $t('weekOpening.tooltipMessage') }}
              </div>
            </div>
            </div>
        </v-col>
        <DaySchedule
          v-for="schedule in schedules"
          :key="schedule.key"
          :schedule="schedule"
          :availableHours="availableHours"
          class="px-1"
        />
      </v-row>
    </v-container>
  </StepTemplate>
</template>

<script>
import DaySchedule from '@/components/onboarding/UI/DaySchedule'
import StepTemplate from '@/components/onboarding/UI/StepTemplate'

export default {
  name: 'StepSchedule',
  components: { DaySchedule, StepTemplate },
  props: {
    error: {
      type: String
    },
    schedules: {
      type: Array,
      required: true
    }
  },
  computed: {
    availableHours() {
      // Settings
      let increment = 0.5 // Define hour's slice used
      let hourStart = 0
      let hourEnd = 23.5
      let availableHours = []
      for (let i = hourStart; i <= hourEnd; i += increment) {
        availableHours.push(this.$options.filters.formatHour(i, this.currentLocale))
      }
      return availableHours
    },
    hasOneDayActive() {
      let submitable = false
      for (let schedule of this.schedules) {
        schedule.active && (submitable = true)
      }
      return submitable
    },
    // TODO Temp : Use global && common plugin to do that
    currentLocale() {
      return new Intl.Locale(window.navigator.language || window.navigator.languages[0]).region
    }
  },
  filters: {
    formatHour(value, currentLocale) {
      let period = ''
      let display
      // Locale dependent
      // EN => am/pm format
      if (currentLocale === 'EN') {
        if (value >= 13) {
          period = ' pm'
          display = ('0' + Math.floor(value - 12)).slice(-2)
        } else {
          period = ' am'
          display = ('0' + Math.floor(value)).slice(-2)
        }
        // OTHERS => regular 24h format
      } else {
        display = ('0' + Math.floor(value)).slice(-2)
      }
      // => Float hours
      let floatHour = value - Math.floor(value)
      floatHour === 0.5 ? (display += ':30') : (display += ':00')
      // => Apply period
      display += period
      return { value, display }
    }
  }
}
</script>

<style scoped lang="scss">
.Step-container {
  > .row:nth-child(1) {
    flex-wrap: nowrap;
  }
}

.Container-head {
  padding-right: 25px;
  margin-top: 5px;
  display: flex;
  justify-content: space-around;
  flex-direction: column;
  font-size: 0.9rem;
  > * {
    margin: 5px 0;
    word-break: break-all;
  }
}

.Row-label {
  height: 40px;
  display: flex;
  justify-content: left;
  align-items: center;
  margin-bottom: 30px;
  padding-top: 4px;
}

.Row-start,
.Row-end {
  display: flex;
  justify-content: left;
  height: 40px;
  padding-top: 4px;
}

.WeekOpening--small {
  display: flex;
  position: relative;
  font-size: .9rem;
}

.WeekOpenings-tooltips {
  .WeekOpenings-tooltipButton{
    flex-shrink: 1;
    top: 0;
    right: -1.4rem;
    display: block;
    width: 1.2rem;
    height: 1.2rem;
    font-size: .8rem;
    font-weight: bold;
    border-radius: 50%;
    text-align: center;
    line-height: 1.2rem;
    color: #fff;
    background: rgba(61, 66, 77, 0.9);
    margin-left:5px;
  }

  .WeekOpenings-tooltipsContent {
    display: none;
    position: absolute;
    bottom: 0;
    left: calc(100% + 20px);
    color: var(--v-text-base);
    font-weight: normal;
    font-size: .9rem;
    z-index: 10;
    min-height: 60px;
    width: 270px;
    text-align: left;
    background: #fff;
    box-shadow: 0px 0px 10px rgba(0, 0, 0, 0.2);
    padding: 10px 15px;
  }

  &:hover .WeekOpenings-tooltipsContent {
    display: block;
  }
}
</style>
